import { isApiError } from '@/guards'
import type ApiError from '@a24/av-sdk/api-error'

type ErrorMsgProps = {
  state: ApiError | any
}

export const ErrorMsg = ({ state }: ErrorMsgProps) => {
  console.debug('ErrorMsg :: state -', state)
  return (
    <p className='text-heritage-red-full body-lg pt-4 pb-4'>
      <span>
        {isApiError(state) && state.exception ? (
          <>
            <strong>
              {state.exception.message ||
                state.message ||
                'Something went wrong.'}
            </strong>{' '}
            &nbsp;
            <span>
              Please refresh and try again, or for further aassistance, please
              email us at &nbsp;
              <a
                className='underline hover:no-underline'
                href={
                  'mailto:help@cherrylanetheatre.org?subject=Something%20went%20wrong'
                }
              >
                help@cherrylanetheatre.org
              </a>
            </span>
          </>
        ) : (
          <>
            <strong
              className='cursor-help'
              title={JSON.stringify(state, null, 2)}
            >
              Something went wrong
            </strong>
            :&nbsp;
            <span>
              Please refresh your browser and try again. If you have repeated
              issues, please email us at &nbsp;
              <a
                className='underline hover:no-underline'
                href={
                  'mailto:help@cherrylanetheatre.org?subject=Something%20went%20wrong'
                }
              >
                help@cherrylanetheatre.org
              </a>
            </span>
          </>
        )}
      </span>
    </p>
  )
}
